import tw, { styled } from 'twin.macro'
import CheckIcon from '@components/Icons/ImportantIcon'
import { useTranslation } from '@i18n'
import Toast from './Toast'

const Container = styled(Toast)`
  ${tw`bg-primary-light text-secondary-normal text-secondary-normal`}
  border-color: #f7c7c7;
  color: #e23838;
  background-color: rgba(252, 235, 235, var(--bg-opacity));
`

const FailToast = () => {
  const { t } = useTranslation('editor')

  return (
    <Container>
      <CheckIcon />
      <span>{t('autosave.label_failed')}</span>
    </Container>
  )
}

export default FailToast
